import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    wx_config_success: null,
    life_hall_poster: null, // 用户自己写的
    loading: {
      show: false,
      text: '',
      mask: true,
    },
  },

  mutations: {
    SET_LOADING(state, data) {
      state.loading = { ...state.loading, ...data }
    },
    SET_USER_INFO(state, data) {
      state.userInfo = data
    },
    SET_WX_CONFIG_STATUS(state, data) {
      state.wx_config_success = data
    },
    SET_LIFE_HALL_POSTER(state, data) {
      console.log('------', data)
      state.life_hall_poster = data
      console.log(state)
    },
  },
  actions: {
    wxConfSuccess(context) {
      context.commit('SET_WX_CONFIG_STATUS', true)
    },
    setStoreUserInfo(context, data) {
      context.commit('SET_USER_INFO', { ...this.userInfo, ...data })
    },
    showLoading(context, text) {
      context.commit('SET_LOADING', { show: true, text })
    },
    hideLoading(context, text) {
      context.commit('SET_LOADING', { show: false, text })
    },
  },
})
